import React from "react";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { orange } from '@mui/material/colors';
import Alert from '@mui/material/Alert';
import { useNavigate } from 'react-router-dom';
import { startRemoveExpense } from '../actions/expenses';
import { useDispatch } from 'react-redux';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';

const ExpenseForm = (props) => {

    const dispatch=useDispatch();
    const navigate=useNavigate();
    const primary=orange[800];
    const [date, setDate] = React.useState(props.expense? props.expense.createdAt : null);

    const [state,setState] = React.useState({
        description: props.expense? props.expense.description : '',
        amount: props.expense? props.expense.amount : 0,
        note: props.expense? props.expense.note : '',
        createdAt: props.expense? props.expense.createdAt : new Date().getTime(),
    });

    const [error,setError] = React.useState(undefined);

    function change(e) {

        const name=e.target.name;
        let value=e.target.value;

        if (name==='amount') {
            if (!value.match(/^\d{1,}(\.\d{0,2})?$/)) {
                return;
            } else {
                value=parseFloat(value);
            }
        }

        setState((prevState) => {
            return {
                ...prevState,
                [name]:value
            }
        });
    }

    function submit(e) {

        e.preventDefault();

        if (!state.description || !state.amount) {
            setError('Please provide description and amount');
            return;
        }

        let createdAt;

        if (date===null) {
            createdAt=new Date().getTime();
        } else {
            createdAt=new Date(date).getTime();
        }

        const currState=state;
        currState.createdAt=createdAt;

        setState({
            description: '',
            amount: 0,
            note: '',
            createdAt:0,
        });

        console.log(currState);
        props.onSubmit(currState);
    }

    return (
        <div className="">

            <form 
                action="" 
                onSubmit={submit} 
                className="expense-form d-flex flex-column" 
            >

                {error && <Alert severity="error" className="expense-page-error">{error}</Alert>}

                <TextField 
                    className="expense-form-input"
                    type="text"
                    id="" 
                    label="Description" 
                    name="description"
                    variant="standard"
                    margin="dense"
                    fullWidth
                    value={state.description}
                    onChange={(e) => {
                        change(e)
                    }}
                />

                <TextField 
                    className="expense-form-input"
                    type="number"
                    id="" 
                    label="Amount" 
                    name="amount"
                    variant="standard"
                    margin="dense"
                    fullWidth
                    value={state.amount}
                    onChange={(e) => {
                        change(e)
                    }}
                />

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        label="Creation Date"
                        value={date}
                        name="createdAt"
                        onChange={(e) => {
                            setDate(e);
                        }}
                        renderInput={(params) => 
                            <TextField 
                                className="expense-form-input" 
                                margin="dense" 
                                variant="standard" 
                                {...params}
                            />
                        }
                    />
                </LocalizationProvider>

                <TextField 
                    className="expense-form-input"
                    type="text"
                    id="" 
                    label="Note" 
                    name="note"
                    variant="standard"
                    margin="dense"
                    multiline
                    fullWidth
                    rows={10}
                    value={state.note}
                    onChange={(e) => {
                        change(e)
                    }}
                />

                <Button 
                    type="submit"
                    variant='contained'
                    className='login-logout-button'
                    style={{backgroundColor:primary}}
                >
                    {props.expense ? 'Edit' : 'Add'}
                </Button>
                
                {
                    props.expense ?
                    <Button 
                        variant='contained'
                        className='login-logout-button'
                        style={{backgroundColor:primary}}
                        onClick={() => {
                            dispatch(startRemoveExpense({ id: props.expense.id }))
                            navigate('/');
                        }}
                    >Remove</Button>
                    : ""
                }
            </form>
        </div>
    );
};

export default ExpenseForm;